




















































import { defineComponent, ref, computed } from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import { moduleList } from '@/views/Report/Management/management-router';
import useAuth from '@/useAuth';

const PartOfDrawer = defineComponent({
  props: {
    icon: {},
    label: {},
    to: {
      type: [String, Object],
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    iconClass: { type: String },
    modelValue: {
      type: String,
      default: undefined,
    },
    padding: {},
    disableActive: { type: Boolean },
  },
  setup(props, emit) {
    const { router, route } = useRouter();
    const state = ref('gray');
    const expand = ref(false || props.active);
    const { hasPermission } = useAuth();

    function resetScrollPosition() {
      window.scrollTo(0, 0);
    }
    // eslint-disable-next-line
    const alterActiveClass = computed(() => props.disableActive ? 'disable-active' : '');

    function redirect(to: string) {
      if (route.value.name !== to) {
        router.push({ name: to });
        resetScrollPosition();
      }
    }

    return {
      state,
      redirect,
      hasPermission,
      moduleList,
      expand,
      resetScrollPosition,
      alterActiveClass,
    };
  },
});

export default PartOfDrawer;
